import React, { useState } from 'react';
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic';
import { TableHeader } from '../../components/Table/TableHeader';
import { useSelector } from 'react-redux';
import { getQuality } from '../../app/reducers/Quality/qualitySlice';

const ChallanSelectPopup = ({
    challanSelectPopupOpen,
    setChallanSelectPopupOpen,
    formik,
    currentPoData,
    setCurrentPoData,
}) => {
    const [selectedPoChallans, setSelectedPoChallans] = useState([]);
    const { quality } = useSelector(getQuality);
    const tableHeader = [
        { name: 'Select' },
        { name: 'Mill Name' },
        { name: 'Challan No' },
        { name: 'Lot No' },
        { name: 'quality' },
        { name: 'Weaver Name' },
        { name: 'Grey Challan No' },
        { name: 'Grey Meter' },
        { name: 'Mill Meter' },
    ];
    console.log(currentPoData);
    return (
        <ModalBasic
            max_width="w-[900px]"
            modalOpen={challanSelectPopupOpen}
            setModalOpen={setChallanSelectPopupOpen}
        >
            <div className="p-4">
                <table className="w-full">
                    <TableHeader headers={tableHeader} />
                    <tbody>
                        {currentPoData?.map((ele) => {
                            return (
                                <tr>
                                    <td className="text-center">
                                        <input
                                            type="checkbox"
                                            checked={formik.values.poData.find(
                                                (item) =>
                                                    item.millChallanNo ===
                                                    ele.millChallanNo
                                            )}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    console.log(ele);
                                                    formik.setFieldValue(
                                                        'poData',
                                                        [
                                                            ...formik.values
                                                                .poData,
                                                            ele,
                                                        ]
                                                    );
                                                } else {
                                                    const updatedPoData =
                                                        formik.values.poData.filter(
                                                            (item) =>
                                                                item.challanNo !==
                                                                ele.challanNo
                                                        );
                                                    formik.setFieldValue(
                                                        'poData',
                                                        updatedPoData
                                                    );
                                                }
                                            }}
                                        />
                                    </td>
                                    <td>{ele.millName}</td>
                                    <td>{ele.millChallanNo}</td>
                                    <td>{ele.lotNo}</td>
                                    <td>
                                        {
                                            quality?.docs?.find(
                                                (item) =>
                                                    item._id === ele.quality
                                            )?.name
                                        }
                                    </td>
                                    <td>{ele.weaverName}</td>
                                    <td>{ele.greyChallanNo}</td>
                                    <td>{ele.greyMeter}</td>
                                    <td>{ele.millMeter}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </ModalBasic>
    );
};

export default ChallanSelectPopup;
